import { apiClient } from './api'

export interface AgentPortalPagination {
  page: number
  limit: number
  total: number
  totalPages?: number
}

export interface AgentPortalOverviewResponse {
  agent: {
    id: string
    name: string
    code: string
    status: string
    expiresAt?: string | null
    maxDomains?: number | null
    createdAt?: string
    updatedAt?: string
  }
  stats: {
    domains: number
    users: number
    imageGenerations: number
    videoGenerations: number
    totalGenerations: number
    totalPayments: number
  }
}

export const agentPortalService = {
  getOverview: () => apiClient.get<AgentPortalOverviewResponse>('/agent-portal/overview'),
  getDomains: () => apiClient.get<any[]>('/agent-portal/domains'),
  getUsers: (params: { page?: number; limit?: number }) =>
    apiClient.get<{ items: any[]; pagination: AgentPortalPagination }>('/agent-portal/users', { params }),
  getGenerations: (params: { page?: number; limit?: number; type?: string; status?: string }) =>
    apiClient.get<{ items: any[]; pagination: AgentPortalPagination }>('/agent-portal/generations', { params }),
  getPayments: (params: { page?: number; limit?: number }) =>
    apiClient.get<{ items: any[]; totalAmount: number; pagination: AgentPortalPagination }>('/agent-portal/payments', { params }),
  getPointsLogs: (params: { page?: number; limit?: number }) =>
    apiClient.get<{ items: any[]; pagination: AgentPortalPagination }>('/agent-portal/points-logs', { params }),
}


